import { useEffect, useRef } from 'react'

export const useUpdateEffect = (effect: () => void, deps: any[]) => {
	const isMounted = useRef(false)

	// for react-refresh
	useEffect(
		() => () => {
			isMounted.current = false
		},
		[]
	)

	useEffect(() => {
		if (!isMounted.current) {
			isMounted.current = true
		} else {
			return effect()
		}
	}, deps)
}
